import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-polyglot'

import { Text, Label, Avatar, Icon, Confirm, FlexContainer } from 'components'

class StatusInfo extends PureComponent {
	render() {
		const {
			className,
			lockedBy,
			draft,
			outdated,
			onDraftStateChange,
			onChangeOutdatedState,
			lockedByOtherUser,
			meta: { id },
			t,
		} = this.props

		const initials =
			lockedBy && lockedBy.firstName && lockedBy.lastName
				? lockedBy.firstName.charAt(0) + lockedBy.lastName.charAt(0)
				: 'n/a'
		const name =
			lockedBy &&
			lockedBy.firstName &&
			lockedBy.lastName &&
			`${lockedBy.firstName} ${lockedBy.lastName}`

		return (
			<div className={className}>
				<FlexContainer justifyContent="flex-start" wrap smallSpacing>
					{draft && (
						<>
							<Label
								text={t('status.draft')}
								icon={<Icon name="draft" />}
								onRemove={e => {
									onDraftStateChange(id, !draft)
								}}
							/>
						</>
					)}

					{outdated && (
						<>
							<Confirm
								text={t('tag_as_current_text')}
								buttonText={t('tag_as_current_button')}
							>
								{confirm => (
									<Label
										text={t('status.outdated')}
										icon={<Icon name="outdated" />}
										onRemove={confirm(() => {
											onChangeOutdatedState(id, false)
										})}
									/>
								)}
							</Confirm>
						</>
					)}

					{lockedBy && (
						<>
							<Label
								text={t('status.locked')}
								icon={<Icon name="lock" />}
							/>
						</>
					)}

					{lockedBy && (
						<FlexContainer justifyContent="flex-start" smallSpacing>
							<Avatar
								initials={initials}
								image={lockedBy.image}
								size="small"
							/>
							<Text color="light" size="small" inline>
								{lockedByOtherUser
									? t('status.locked_text', { name })
									: t('status.locked_by_oneself_text')}
							</Text>
						</FlexContainer>
					)}
				</FlexContainer>
			</div>
		)
	}
}

StatusInfo.propTypes = {
	className: PropTypes.string,
	lockedBy: PropTypes.shape({}),
	draft: PropTypes.bool,
}

StatusInfo.defaultProps = {
	className: null,
	lockedBy: null,
	draft: false,
}

export default translate()(StatusInfo)
